import { createFileRoute } from '@tanstack/react-router';
import { DealPage } from '@web/modules/deals/detail/deal-page';

export const Route = createFileRoute('/_app/deals/$dealId')({
  component: DealRoute,
});

function DealRoute() {
  const { dealId } = Route.useParams();
  // Keyed by id: another deal starts with fresh sections (nothing being edited).
  return <DealPage key={dealId} dealId={dealId} />;
}
